import React, {  } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import { LeftArrow } from '../../Asset/svg';
import { Typography, useTheme } from '@mui/material';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setOrderDetails } from '../../redux/orderListing';
import ContributorChatPage from '../../Components/Contributor/ContributorChatPage';

function ContributorChat() {
  const theme = useTheme();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const qid = params.get('qid');
  const id = params.get('id');
  const query=params.get('query');
  const dispatch = useDispatch();
  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
          // bgcolor: theme.backgroundColor.box.main,
          // p: 4,
          // pl: 0,
        };
      }}
    >
      <CustomBox>
        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }}> 
            <Box sx={{
                display: "flex",
                alignItems: "center",
                cursor: 'pointer'
            }} onClick={()=>{
                navigate(-1)
                dispatch(setOrderDetails({}));
            }}>
                <LeftArrow fill={theme.palette.textButton.main}/>
                <Typography variant='h5' sx={{
                    marginLeft: theme.spacing(1),
                    color: theme.palette.textButton.main
                }}>Back</Typography>
            </Box>
            <Typography variant='h5' sx={{marginLeft: (theme)=> theme.spacing(1)}}>Query Thread</Typography>
            <div style={{paddingLeft: 30}}></div>
        </Box>
      </CustomBox>
      <Divder spacing={1} />
      <ContributorChatPage qid={qid} id={id} query={query}/>
      <Divder spacing={1.2} />
    </Box>
  );
}

export default ContributorChat;
